import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';
import { SharedFeatureComponentsModule } from '@digilize/shared/feature/components/src';
import { AlertService } from '@digilize/shared/feature/modules/alert/src';
import { ApiInterceptor } from '@digilize/shared/feature/modules/auth/src';
import { GlobalErrorHandler, GlobalErrorHandlerWithLog } from '@digilize/shared/feature/modules/error-handling';
import { CustomModuleTitleStrategyService } from '@digilize/shared/feature/modules/i18n/src';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material';
import { APP_CONFIG, ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { InlineSVGModule } from '@digilize/shared/ui/inline-svg/src';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';

import { appConfig } from '../environments/app.config';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslocoRootModule } from './transloco-root.module';
import { MainModule } from './views/main.module';

registerLocaleData(localeNl, 'nl-NL');
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    InlineSVGModule.forRoot({ baseUrl: '/assets' }),
    LazyLoadImageModule,
    SharedUiMaterialModule,
    AppRoutingModule,
    MainModule,
    RecaptchaV3Module,
    SharedFeatureComponentsModule,
    SharedUiComponentsModule,
    TranslocoRootModule,
  ],
  providers: [
    AlertService,
    {
      provide: ErrorHandler,
      useClass: environment.production ? GlobalErrorHandlerWithLog : GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB',
    },
    {
      provide: LOCALE_ID,
      useValue: 'nl-NL',
    },
    {
      provide: ENV_CONFIG,
      useValue: environment,
    },
    {
      provide: APP_CONFIG,
      useValue: appConfig,
    },
    { provide: TitleStrategy, useClass: CustomModuleTitleStrategyService },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
